import { Link } from 'react-router-dom';
import { tSettings } from '../../../lib/settings-i18n';

/**
 * 메일 설정이 **어디로 갔는지** 알리는 한 자리 (2026-09-05 → 2026-09-06 사용자 지시).
 *
 * 개인설정의 「메일」 갈래(기본·쓰기·읽기·외부 메일 계정)는 전부 **메일 > 환경설정**으로 옮겼다.
 * 옛 자리를 그냥 지우면 저장해 둔 링크나 기억으로 찾아온 사람이 **빈 화면**을 만난다 —
 * 「없어졌다」와 「옮겼다」는 다른 말이다.
 * ★ 값은 그대로다(표를 안 옮겼다) — 새 자리에서 그대로 보이고, 고치면 같은 서버 칸에 저장된다.
 */
export function MailSettingsMoved({ tab }: { tab?: 'basic' | 'external' }) {
  return (
    <section className="settings-section" aria-label={tSettings('settings.mailmoved.heading')}>
      <h2>{tSettings('settings.mailmoved.heading')}</h2>
      <p className="settings-section-subtitle">{tSettings('settings.mailmoved.desc')}</p>
      <p>
        <Link to={`/mail/settings?tab=${tab ?? 'basic'}`}>{tSettings('settings.mailmoved.link')}</Link>
      </p>
    </section>
  );
}
